module.exports = __webpack_public_path__ + "static/img/5.5f329ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/zh/5.png
// module id = 8AvI
// module chunks = 0